import { canViewByRoleCodes } from "src/core/shared/utils/canViewByRoleCodes";
import { Icons } from "src/library/components/Icon/types";
import { IRoute } from "src/pages/Router/routes";
import AdminMain from "src/pages/Admin";

import { CreateProductReplacementPage } from "./CreateProductReplacementPage";
import ProductReplacementJobsPages from "./ProductReplacementJobsPages";
import ViewQueueJobPage from "../../Settings/ProcessJobQueue/ViewQueueJobPage";

const ProductReplacementRoutes: IRoute[] = [
  {
    exact: true,
    path: "/admin/products/product-replacements",
    pageComponent: ProductReplacementJobsPages,
    title: "Product Replacement Jobs",
    allowedContexts: [],
    menuType: "ADMIN_PRODUCTS",
    roles: [ "admin" ],
    permissions: [ "view-process-jobs" ],
    privateRoute: true,
    parent: AdminMain[ 0 ],
    icon: Icons.HORIZONTALDRAG
  }
];

const ProductReplacementNestedRoutes: IRoute[] = [
  {
    exact: true,
    path: "/admin/products/product-replacements/create",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: CreateProductReplacementPage,
    title: "Product Replacement",
    allowedContexts: [],
    menuType: "EMPTY",
    roles: [ "admin" ],
    permissions: [ "amend-order", "create-global-settings" ],
    privateRoute: true,
    parent: ProductReplacementRoutes[ 0 ],
    icon: Icons.HORIZONTALDRAG
  },
  {
    exact: true,
    path: "/admin/products/product-replacements/:processJobId",
    pageComponent: ViewQueueJobPage,
    title: "Queue Job",
    hidden: true,
    menuType: "EMPTY",
    privateRoute: true,
    parent: ProductReplacementRoutes[ 0 ],
    roles: [ "admin" ]
  }

];

export default [ ...ProductReplacementRoutes, ...ProductReplacementNestedRoutes ];